import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from "@angular/core";

import { EffButtonComponent } from "../eff-button/eff-button.component";
import { EffIconComponent } from "../eff-icon/eff-icon.component";

declare var $: any;

@Component({
    selector: "eff-button-with-confirmation",
    templateUrl: "./eff-button-with-confirmation.component.html",
    styleUrls: ["./eff-button-with-confirmation.component.scss"],
    imports: [EffButtonComponent, EffIconComponent]
})
export class EffButtonWithConfirmationComponent implements AfterViewInit{
    @Input() icon: string;
    @Input() label: string;
    @ViewChild("confirmationButton") confirmationButton: ElementRef;

    showConfirmation: boolean = false;

    @Output() onConfirmation: EventEmitter<any> = new EventEmitter();

    ngAfterViewInit() {
        $(document).click(
            function () {
                this.showConfirmation = false;
            }.bind(this)
        );
    }

    onClick() {
        this.showConfirmation = true;
    }

    onConfirmationClick() {
        this.onConfirmation.emit();
    }
}
